import React from 'react'
import Home from '../../home/Home'
import Land from '../../home/listings/land/Land'

const LandView = () => {
  return (
        <>
        <Home />
        <Land />
        </>
  )
}

export default LandView
